import React from 'react';

import SelectField from '@/components/forms/SelectField';

import styles from './styles.module.scss';

interface Props {
  defaultValue?: sortOptions;
  callback: (selected: sortOptions) => void;
  options?: { title: string; value: string; disabled?: boolean }[];
}
const SortOptions = ({ callback, defaultValue, options }: Props) => {
  return (
    <SelectField
      className={styles.field}
      options={options || SortOptions.options}
      defaultValue={defaultValue}
      onChange={(e) => callback(e?.currentTarget?.value as sortOptions)}
      name="sortBy"
    />
  );
};

SortOptions.options = [
  { title: 'Sort By', value: '', disabled: true },
  { title: 'Recommended', value: 'recommended' },
  { title: 'Popular', value: 'popular' },
  { title: 'Newest', value: 'newest' },
  { title: 'Ending soon', value: 'ending' },
];
export default SortOptions;
